import { makeStyles, Theme } from '@material-ui/core/styles';
const styles = makeStyles(({ palette, variables}: Theme) => ({
    JetAccordionTitle: {
        color: palette.jet?.contentBrand
    },
    JetAccordionTitleDefault: {
        color: palette.jet?.contentDefault
    },
    JetAccordionIcon: {
        color: palette.jet?.contentDefault
    },
    JetAccordion: {
        marginBottom: variables?.spacingB,
        cursor:'pointer',
        boxShadow:'0px 0px 0px 0px #fff',
        '&::before':{
            backgroundColor:'unset'
        },
        '&.Mui-expanded': {
            marginTop: '0px !important',
            marginBottom: variables?.spacingB,
        },
        '& .MuiTouchRipple-root': {
            display: 'none'
        },
        '& .MuiAccordionSummary-root':{
            minHeight:'68px !important'
        },
        '& .MuiAccordionDetails-root':{
            marginTop: '-26px',
            whiteSpace:'pre-line'
        },
        '& .MuiCollapse-wrapperInner':{
            marginTop:'12px'
        }
    }
}))


export default styles;